$('#phone').on('input', function() {
    this.value = this.value.replace(/[^0-9+]/g, '').replace(/(?!^)\+/g, '');
});

$('#feedback').validate({
    ignore: [],
    errorElement: 'div',
    rules: {
        fio: {
            required: true,
            minlength: 2,
            maxlength: 80
        },
        phone: {
            required: true,
            minlength: 10,
            maxlength: 22
        },
        company_name: {
            required: true,
            minlength: 2,
            maxlength: 80
        },
        email: {
            required: true,
            email: true,
            minlength: 5,
            maxlength: 35
        },
        message: {
            required: true,
            minlength: 10,
            maxlength: 100
        }
    },
    submitHandler: function submitHandler(form, event) {
        event.preventDefault();
        $('.feedback-button').addClass('load');
        let ajax_url = $('#feedback').attr('data-form') === 'true' ? '/api/v1/feedback' : '/api/v1/cost_calculation_requests'
        $.ajax({
            type: 'POST',
            url: ajax_url,
            data: $(form).serialize()
        }).done(function (response) {
            $('.feedback-button').removeClass('load')
            $('.success').addClass('active')
            setTimeout(function (){
                $('.success').removeClass('active')
            }, 2500)
            document.getElementById("feedback").reset();
        }).fail(function (error) {
            $('.feedback-btn').removeClass('load')
        });
    }
});
